export default "__VITE_ASSET__bc44a819__"